module.exports = __webpack_public_path__ + "img/living_will.95a3301c.png";